import { CountryCode } from '@constants'
import { type Nullable } from '@dni-types/utilities/nullable'

const CountryCodeSet = new Set(Object.values(CountryCode).map(countryCode => countryCode))

/**
 * This method is case insensitive by default
 */
export const isCountryCode = (countryCode: Nullable<string>, strict?: boolean): countryCode is CountryCode => {
  if (!countryCode) return false
  if (strict) return CountryCodeSet.has(countryCode as CountryCode)
  return CountryCodeSet.has(countryCode.toUpperCase() as CountryCode)
}
